/**
 * Brand Quotes Swiper
 * Re-inits after bundle/combined listing variant change via MutationObserver.
 */
(function () {
  function init() {
    const el = document.querySelector('.brand-quotes__quote-slider .swiper');
    if (!el) return;
    if (el.swiper) el.swiper.destroy(true, true);
    new Swiper(el, {
      updateOnWindowResize: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.brand-quotes .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      centeredSlides: true,
      initialSlide: 4,
      spaceBetween: 24,
      breakpoints: {
        768: { spaceBetween: 80 },
      },
    });
  }

  function watch() {
    const mainEl = document.querySelector('main');
    if (!mainEl) return;
    let debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        const swiperEl = document.querySelector('.brand-quotes__quote-slider .swiper');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;
        init();
      }, 200);
    }).observe(mainEl, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    watch();
  });
})();
